<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonLoanOfficerSearchTitle')" [size]="'large'" (closeModal)="onClose()">
    <div modal-content>
      <p class="font-dm text-sm text-ld-neutral-500 mt-1">{{ t('modalsLoanOfficerSearchSubtitle') }}</p>

      <div id="loan-officer-search-inputs" class="py-4 border-b border-ld-border">
        <mat-form-field id="loan-officer-name-search-field" appearance="outline" class="w-full profile-field">
          <mat-label>{{ t('modalsLoanOfficerSearchSearchByName') }}</mat-label>
          <input
            matInput
            id="loan-officer-name-search-input"
            [formControl]="nameSearchControl"
            type="text"
            [placeholder]="t('modalsLoanOfficerSearchNamePlaceholder')"
            (keyup.enter)="onSearchByName()"
          />
          <mat-icon matSuffix class="text-ld-neutral-500 cursor-pointer" (click)="onSearchByName()">search</mat-icon>
        </mat-form-field>

        <div class="flex items-center gap-4 my-3">
          <div class="flex-1 h-px bg-ld-border"></div>
          <span class="font-dm text-sm text-ld-neutral-500">{{ t('commonOr') }}</span>
          <div class="flex-1 h-px bg-ld-border"></div>
        </div>

        <mat-form-field id="loan-officer-zip-search-field" appearance="outline" class="w-full profile-field">
          <mat-label>{{ t('modalsLoanOfficerSearchSearchByZip') }}</mat-label>
          <input
            matInput
            id="loan-officer-zip-search-input"
            [formControl]="zipSearchControl"
            type="text"
            [placeholder]="t('modalsLoanOfficerSearchZipPlaceholder')"
            maxlength="5"
            (keyup.enter)="onSearchByZip()"
          />
          <mat-icon matSuffix class="text-ld-neutral-500 cursor-pointer" (click)="onSearchByZip()">search</mat-icon>
        </mat-form-field>
      </div>

      <div id="loan-officer-search-results" class="py-4 min-h-[200px]">
        @if (isLoading()) {
          <div id="loan-officer-search-loading" class="flex flex-col items-center justify-center py-8">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="font-dm text-sm text-ld-neutral-500 mt-4">{{ t('commonSearching') }}</p>
          </div>
        }

        @if (errorMessage()) {
          <div id="loan-officer-search-error" class="flex flex-col items-center justify-center py-8" role="alert">
            <img [src]="errorIcon" alt="Error" class="w-10 h-10" />
            <p class="font-dm text-sm text-ld-neutral-500 mt-2">{{ errorMessage() }}</p>
          </div>
        }

        @if (noResults() && !errorMessage()) {
          <div id="loan-officer-search-no-results" class="flex flex-col items-center justify-center py-8">
            <mat-icon class="text-ld-neutral-200 text-5xl! h-auto!">person_search</mat-icon>
            <p class="font-dm text-sm text-ld-neutral-500 mt-2">{{ t('modalsLoanOfficerSearchNoResults') }}</p>
            <p class="font-dm text-xs text-ld-neutral-400 mt-1">{{ t('commonTryDifferentSearch') }}</p>
          </div>
        }

        @if (!isLoading() && searchResults().length > 0) {
          <div id="loan-officer-results-list" class="flex flex-col gap-3">
            @for (officer of searchResults(); track officer.loanOfficerId || officer.id) {
              <button
                [id]="'loan-officer-result-' + (officer.loanOfficerId || officer.id)"
                type="button"
                class="flex items-center gap-4 p-4 bg-ld-neutral-50 rounded-xl hover:bg-ld-primary-50 transition-colors cursor-pointer text-left w-full group"
                (click)="onSelectOfficer(officer)"
              >
                <div
                  class="size-12 rounded-full bg-ld-neutral-200 flex items-center justify-center overflow-hidden shrink-0"
                >
                  @if (officer.headshotUrl && !isBrokenImage(officer.headshotUrl)) {
                    <img
                      [src]="officer.headshotUrl"
                      [alt]="getDisplayName(officer)"
                      class="size-full object-cover"
                      (error)="onImageLoadError(officer.headshotUrl!)"
                    />
                  } @else {
                    <span class="font-dm font-medium text-ld-neutral text-sm">
                      {{ getInitials(officer.preferredName) }}
                    </span>
                  }
                </div>
                <div class="flex-1 min-w-0">
                  <p class="font-dm font-medium text-base text-ld-neutral truncate group-hover:text-ld-primary">
                    {{ getDisplayName(officer) }}
                  </p>
                  @if (officer.title) {
                    <p class="font-dm text-sm text-ld-neutral-500 truncate">{{ officer.title }}</p>
                  }
                  <p class="font-dm text-xs text-ld-neutral-400 truncate">{{ getLocation(officer) }}</p>
                  @if (officer.nmlsId) {
                    <p class="font-dm text-xs text-ld-neutral-400">{{ t('commonLabelsNmls') }} {{ officer.nmlsId }}</p>
                  }
                </div>
                <mat-icon class="text-ld-neutral-400 group-hover:text-ld-primary shrink-0">chevron_right</mat-icon>
              </button>
            }
          </div>
        }

        @if (!hasSearched() && !isLoading()) {
          <div id="loan-officer-search-initial" class="flex flex-col items-center justify-center py-8">
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsLoanOfficerSearchInitialPrompt') }}</p>
          </div>
        }
      </div>
    </div>
    <div modal-footer>
      <button id="loan-officer-search-cancel-btn" type="button" class="btn-outline-ld-purple" (click)="onClose()">
        {{ t('commonButtonsCancel') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
